import React from 'react';
import {
    SP_SKIP, extractResponseData, SmartStyles, SmartHeader, SmartSection, NoRecordsCard, RawResponseButton
} from './_SmartFieldRenderer';

const GROUPS = {
    consumer: { title: 'CONSUMER DETAILS', icon: 'pi-user',        keys: ['consumer_name', 'consumer_number', 'account_number', 'id_number', 'address', 'city', 'state', 'pincode', 'email', 'mobile'] },
    billing:  { title: 'BILLING DETAILS',  icon: 'pi-dollar',      keys: ['bill_amount', 'bill_date', 'bill_due_date', 'bill_number', 'bill_period', 'amount_payable', 'total_amount', 'net_amount', 'last_payment_amount', 'last_payment_date', 'arrear_amount'] },
    supply:   { title: 'SUPPLY DETAILS',   icon: 'pi-bolt',        keys: ['operator_code', 'operator_name', 'division', 'sub_division', 'connection_type', 'category', 'load', 'meter_number', 'sanctioned_load', 'supply_type'] },
    usage:    { title: 'USAGE DETAILS',    icon: 'pi-chart-bar',   keys: ['units_consumed', 'current_reading', 'previous_reading', 'reading_date'] },
};

const HIGHLIGHT = ['consumer_name', 'bill_amount', 'amount_payable', 'bill_due_date'];

const ElectricityBillOutputComponent = ({ reportData, hideCredits, isSharedView }) => {
    const shouldHideCredits = hideCredits || isSharedView;
    const { responseData, remainingBalance, errorMsg, hasRealData } = extractResponseData(reportData);

    if (!reportData) return <NoRecordsCard subtitle="No data available" />;
    if (!responseData || !hasRealData) {
        return <NoRecordsCard errorMsg={errorMsg} subtitle="No records found for the provided consumer number. Please verify and try again." />;
    }

    const d = responseData;
    const grouped = {};
    for (const [groupName, group] of Object.entries(GROUPS)) {
        const picked = {};
        group.keys.forEach(k => { if (k in d && d[k] !== null && d[k] !== undefined && d[k] !== '') picked[k] = d[k]; });
        if (Object.keys(picked).length > 0) grouped[groupName] = picked;
    }
    const knownKeys = new Set(Object.values(GROUPS).flatMap(g => g.keys));
    const leftover = {};
    for (const [k, v] of Object.entries(d)) {
        if (SP_SKIP.has(k) || knownKeys.has(k)) continue;
        if (v === null || v === undefined || v === '') continue;
        leftover[k] = v;
    }

    return (
        <div>
            <SmartStyles />
            <SmartHeader title="Electricity Bill Report" icon="pi-bolt" remainingBalance={remainingBalance} shouldHideCredits={shouldHideCredits} />
            <div className="horizontal-report-card">
                {Object.entries(GROUPS).map(([groupName, meta]) => (
                    grouped[groupName]
                        ? <SmartSection key={groupName} title={meta.title} icon={meta.icon} data={grouped[groupName]} highlightKeys={HIGHLIGHT} />
                        : null
                ))}
                {Object.keys(leftover).length > 0 && (
                    <SmartSection title="OTHER DETAILS" icon="pi-info-circle" data={leftover} />
                )}
                <RawResponseButton data={d} />
            </div>
        </div>
    );
};

export default ElectricityBillOutputComponent;
